import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppHeaderComponent } from './shared/app-header.component';
import { AppSidebarComponent } from './shared/app-sidebar.component';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AppService } from './shared/services/app.service';
import { TranslationService } from './shared/services/translation.service';
import { NotificationService } from './shared/services/notification.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AppHeaderComponent, AppSidebarComponent, CommonModule, MatSidenavModule, TranslateModule, MatSnackBarModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'frontend';
  isLoginPage = false;

  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  public app = inject(AppService);
  private translation = inject(TranslationService);
  private notification = inject(NotificationService);

  ngOnInit() {
    // Sprawdzaj zmianę trasy i aktualizuj isLoginPage
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (event instanceof NavigationEnd) {
        this.isLoginPage = this.checkIfLoginPage(event.url);
        this.app.toggleSidenav(false)
        this.cdr.detectChanges();
      }
    });

    // Sprawdź aktualną trasę przy inicjalizacji
    this.isLoginPage = this.checkIfLoginPage(this.router.url);
    this.cdr.detectChanges();

    // small demo message so snack-bar dependency is exercised globally
    if (!this.isLoginPage) {
      this.notification.success('Witaj w panelu administracyjnym');
    }
  }

  private checkIfLoginPage(url: string): boolean {
    // Usuń parametry query i sprawdź tylko ścieżkę
    const path = url.split('?')[0];
    return path === '/login' || path === '/' || path.startsWith('/login/');
  }
}
